// Quiz icons, second batch: topics that came up often in the question bank
// but had no icon yet. Same rules as science.js.
export const MORE_ICONS = [
  { id: "dinosaur", en: "Dinosaur", da: "Dinosaur", svg: `
<path d="M22 92 q-14 -4 -16 -18 q14 8 26 6 q4 -26 30 -30 q6 -26 26 -24 q16 2 14 14 q-2 8 -14 8 l-4 16 q10 6 10 24 h-12 v-10 h-26 v10 h-12 v-8 q-14 6 -22 12Z" fill="#7BD389"/>
<circle cx="94" cy="26" r="3.5" stroke="none" fill="#3B3355"/>
<path d="M86 36 q6 3 12 0" fill="none" stroke-width="3"/>
<path d="M50 48 l4 -8 4 8 M62 46 l4 -8 4 7" fill="#FFC857" stroke-width="3"/>
<circle cx="52" cy="66" r="4" stroke="none" fill="#5BB46C"/><circle cx="66" cy="72" r="3" stroke="none" fill="#5BB46C"/>
<circle cx="88" cy="32" r="4" stroke="none" fill="#FF9BB0" opacity=".7"/>` },

  { id: "whale", en: "Whale", da: "Hval", svg: `
<path d="M40 22 q-6 -10 0 -16 M40 22 q6 -10 14 -10 M40 22 q-10 -6 -18 -2" fill="none" stroke="#7FC8F8" stroke-width="4"/>
<path d="M10 62 C10 36 50 28 74 40 C88 46 94 58 100 62 L112 48 L114 76 L102 72 C94 88 70 96 46 94 C24 92 10 80 10 62Z" fill="#4A90D9"/>
<path d="M12 70 C26 88 60 90 84 80 C72 92 44 96 26 88 C18 84 14 78 12 70Z" fill="#B7E0FB"/>
<path d="M18 74 h8 M26 78 h10 M38 80 h10" fill="none" stroke-width="3"/>
<circle cx="30" cy="56" r="4" stroke="none" fill="#3B3355"/>
<path d="M56 72 q8 8 16 2" fill="#4A90D9" stroke-width="3"/>
<path d="M4 108 q14 -6 28 0 t28 0 t28 0 t28 0" fill="none" stroke="#7FC8F8" stroke-width="4"/>` },

  { id: "chicken", en: "Chicken", da: "Høne", svg: `
<path d="M50 30 q-6 -14 4 -18 q4 6 6 0 q8 -4 8 6 q6 2 2 10" fill="#E8556D"/>
<path d="M30 96 C14 86 14 60 28 54 C26 34 38 24 54 26 C72 28 76 44 72 54 C86 46 100 44 108 34 C108 60 100 82 84 92 C70 100 46 104 30 96Z" fill="#fff"/>
<path d="M28 44 l-12 4 12 6Z" fill="#FFC857"/>
<path d="M30 58 q-6 6 0 10 q4 -2 0 -10Z" fill="#E8556D" stroke-width="3"/>
<circle cx="42" cy="42" r="3.5" stroke="none" fill="#3B3355"/>
<path d="M58 70 q14 10 28 0" fill="none" stroke="#C9CCE0" stroke-width="4"/>
<path d="M50 100 v12 l-6 2 M66 100 v12 l6 2" fill="none" stroke="#FF7A45" stroke-width="4"/>` },

  { id: "snail", en: "Snail", da: "Snegl", svg: `
<path d="M10 96 C30 96 80 98 104 92 C112 90 112 80 104 78 L82 82 L22 84 C12 86 8 92 10 96Z" fill="#FFC857"/>
<path d="M90 80 C96 66 98 54 94 46 M98 80 C108 70 110 60 108 52" fill="none" stroke-width="4"/>
<circle cx="94" cy="44" r="4" fill="#3B3355"/><circle cx="108" cy="50" r="4" fill="#3B3355"/>
<circle cx="52" cy="58" r="32" fill="#E07A5F"/>
<path d="M52 58 m-4 0 a4 4 0 1 1 8 0 a10 10 0 0 1 -18 2 a16 16 0 0 1 28 -10 a22 22 0 0 1 -14 30" fill="none" stroke-width="4"/>
<path d="M30 40 q4 -8 12 -12" fill="none" stroke="#fff" stroke-width="4" opacity=".7"/>` },

  { id: "earthquake", en: "Earthquake", da: "Jordskælv", svg: `
<path d="M6 62 h46 l-8 14 l14 10 l-10 26 h-42Z" fill="#B07A57"/>
<path d="M114 62 h-48 l-6 14 l12 10 l-8 26 h50Z" fill="#B07A57"/>
<path d="M6 62 h46 M66 62 h48" fill="none" stroke="#7BD389" stroke-width="7"/>
<path d="M20 48 q4 -6 0 -12 M34 44 q4 -6 0 -12 M86 44 q4 -6 0 -12 M100 48 q4 -6 0 -12" fill="none" stroke="#FF7A45" stroke-width="4"/>
<path d="M44 30 h10 v-10 h10 v10 h10 v22 h-30Z" fill="#FFF3DC" transform="rotate(-10 59 40)"/>
<circle cx="24" cy="86" r="3" stroke="none" fill="#8E5E40"/><circle cx="94" cy="96" r="3" stroke="none" fill="#8E5E40"/>` },

  { id: "galaxy", en: "Galaxy", da: "Galakse", svg: `
<circle cx="60" cy="60" r="50" fill="#3B3355"/>
<path d="M60 60 C60 40 86 36 94 52 C100 64 90 80 74 82 M60 60 C60 80 34 84 26 68 C20 56 30 40 46 38" fill="none" stroke="#A78BFA" stroke-width="12"/>
<path d="M60 60 C60 40 86 36 94 52 C100 64 90 80 74 82 M60 60 C60 80 34 84 26 68 C20 56 30 40 46 38" fill="none" stroke="#E5E1EE" stroke-width="4"/>
<circle cx="60" cy="60" r="9" fill="#FFE37A" stroke="none"/>
<circle cx="30" cy="30" r="2.5" fill="#fff" stroke="none"/><circle cx="92" cy="28" r="2" fill="#fff" stroke="none"/><circle cx="96" cy="92" r="2.5" fill="#fff" stroke="none"/><circle cx="24" cy="88" r="2" fill="#fff" stroke="none"/><circle cx="76" cy="18" r="1.8" fill="#fff" stroke="none"/>` },

  { id: "constellation", en: "Stars", da: "Stjerner", svg: `
<rect x="8" y="8" width="104" height="104" rx="22" fill="#3B3355"/>
<path d="M26 82 L44 64 L66 72 L80 42 L98 30 M66 72 L86 88" fill="none" stroke="#B7E0FB" stroke-width="3" stroke-dasharray="2 6"/>
<g fill="#FFE37A" stroke="#FFE37A" stroke-width="2"><path d="M26 76 l2 4 4 2 -4 2 -2 4 -2 -4 -4 -2 4 -2z"/><path d="M44 58 l2 4 4 2 -4 2 -2 4 -2 -4 -4 -2 4 -2z"/><path d="M66 66 l2 4 4 2 -4 2 -2 4 -2 -4 -4 -2 4 -2z"/><path d="M80 34 l3 6 6 2 -6 2 -3 6 -3 -6 -6 -2 6 -2z"/><path d="M98 24 l2 4 4 2 -4 2 -2 4 -2 -4 -4 -2 4 -2z"/><path d="M86 82 l2 4 4 2 -4 2 -2 4 -2 -4 -4 -2 4 -2z"/></g>
<circle cx="30" cy="30" r="9" fill="#FFF3DC" stroke="none"/><circle cx="34" cy="27" r="8" fill="#3B3355" stroke="none"/>` },

  { id: "satellite", en: "Satellite", da: "Satellit", svg: `
<g transform="rotate(-30 60 60)"><rect x="8" y="48" width="32" height="24" fill="#4A90D9"/><rect x="80" y="48" width="32" height="24" fill="#4A90D9"/>
<path d="M18 48 v24 M29 48 v24 M90 48 v24 M101 48 v24 M8 60 h32 M80 60 h32" fill="none" stroke="#B7E0FB" stroke-width="2.5"/>
<path d="M40 60 h40" fill="none" stroke-width="5"/>
<rect x="46" y="44" width="28" height="32" rx="4" fill="#C9CCE0"/>
<path d="M60 44 v-14" fill="none"/><circle cx="60" cy="28" r="4" fill="#E8556D"/></g>
<path d="M86 96 q8 -8 16 0 M92 104 q4 -4 8 0" fill="none" stroke="#FFC857" stroke-width="4" transform="rotate(-30 92 98)"/>` },

  { id: "ear", en: "Hearing", da: "Hørelse", svg: `
<path d="M40 50 C40 26 58 14 74 16 C92 18 102 34 98 52 C96 64 86 68 82 78 C78 88 80 98 70 104 C60 110 48 104 46 96" fill="#FFC9A8"/>
<path d="M56 52 C56 38 66 32 74 34 C84 36 86 48 80 56 C76 62 70 62 70 70 C70 78 62 80 58 74" fill="none" stroke="#E07A5F" stroke-width="4"/>
<path d="M14 40 q-8 14 0 28 M24 46 q-4 8 0 16" fill="none" stroke="#7FC8F8" stroke-width="5"/>` },

  { id: "microbe", en: "Germs", da: "Bakterier", svg: `
<path d="M60 16 l0 -8 M60 104 l0 8 M16 60 h-8 M104 60 h8 M29 29 l-6 -6 M91 91 l6 6 M91 29 l6 -6 M29 91 l-6 6" fill="none" stroke-width="5"/>
<circle cx="60" cy="8" r="4" fill="#7BD389"/><circle cx="60" cy="112" r="4" fill="#7BD389"/><circle cx="8" cy="60" r="4" fill="#7BD389"/><circle cx="112" cy="60" r="4" fill="#7BD389"/>
<path d="M60 18 C86 18 102 34 102 60 C102 86 86 102 60 102 C34 102 18 86 18 60 C18 34 34 18 60 18Z" fill="#9BE3A6"/>
<circle cx="46" cy="52" r="7" fill="#fff"/><circle cx="74" cy="52" r="7" fill="#fff"/><circle cx="47" cy="53" r="3.5" fill="#3B3355" stroke="none"/><circle cx="75" cy="53" r="3.5" fill="#3B3355" stroke="none"/>
<path d="M50 72 q10 8 20 0" fill="none"/>
<circle cx="36" cy="80" r="4" fill="#7BD389" stroke-width="2.5"/><circle cx="84" cy="78" r="3" fill="#7BD389" stroke-width="2.5"/><circle cx="62" cy="32" r="3" fill="#7BD389" stroke-width="2.5"/>` },

  { id: "bloodcell", en: "Blood", da: "Blod", svg: `
<ellipse cx="48" cy="56" rx="34" ry="30" fill="#E8556D"/><ellipse cx="48" cy="56" rx="16" ry="13" fill="#C8404F"/>
<ellipse cx="86" cy="84" rx="26" ry="22" fill="#FF6B81"/><ellipse cx="86" cy="84" rx="11" ry="9" fill="#E8556D"/>
<circle cx="92" cy="30" r="16" fill="#fff"/><circle cx="88" cy="26" r="4" fill="#C9CCE0" stroke="none"/><circle cx="96" cy="34" r="3" fill="#C9CCE0" stroke="none"/>
<path d="M28 42 q4 -6 10 -8" fill="none" stroke="#fff" stroke-width="4" opacity=".7"/>` },

  { id: "soundwave", en: "Sound waves", da: "Lydbølger", svg: `
<path d="M14 46 h18 l24 -20 v68 l-24 -20 h-18Z" fill="#7FC8F8"/>
<path d="M70 44 q10 16 0 32 M82 34 q18 26 0 52 M94 24 q26 36 0 72" fill="none" stroke="#3B3355" stroke-width="10"/>
<path d="M70 44 q10 16 0 32 M82 34 q18 26 0 52 M94 24 q26 36 0 72" fill="none" stroke="#FFC857" stroke-width="4"/>` },

  { id: "seesaw", en: "Simple machines", da: "Simple maskiner", svg: `
<path d="M60 70 L44 104 H76Z" fill="#E8556D"/>
<g transform="rotate(-14 60 68)"><rect x="8" y="62" width="104" height="10" rx="4" fill="#FFC857"/></g>
<rect x="88" y="30" width="20" height="20" rx="3" fill="#7FC8F8" transform="rotate(-14 98 40)"/>
<circle cx="22" cy="68" r="10" fill="#7BD389"/>
<path d="M30 106 h60" fill="none"/>` },

  { id: "church", en: "Church", da: "Kirke", svg: `
<path d="M60 4 v16 M54 10 h12" fill="none" stroke-width="4"/>
<path d="M48 44 L60 20 L72 44Z" fill="#E8556D"/>
<rect x="48" y="44" width="24" height="62" fill="#fff"/>
<path d="M72 60 h36 v46 h-36Z M14 70 h34 v36 h-34Z" fill="#FFF3DC"/>
<path d="M72 60 L90 44 L108 60Z M14 70 L31 56 L48 70Z" fill="#E8556D"/>
<path d="M54 106 v-16 a6 6 0 0 1 12 0 v16" fill="#B07A57"/>
<circle cx="60" cy="58" r="6" fill="#FFC857"/>
<path d="M82 74 v10 a4 4 0 0 0 8 0 v-10 a4 4 0 0 0 -8 0Z M24 80 v10 a4 4 0 0 0 8 0 v-10 a4 4 0 0 0 -8 0Z" fill="#7FC8F8" stroke-width="3"/>
<path d="M6 106 h108" fill="none"/>` },

  { id: "oillamp", en: "Lamp", da: "Lampe", svg: `
<path d="M60 22 C64 30 70 34 68 44 C66 50 62 52 60 52 C56 52 52 48 52 44 C52 36 58 32 60 22Z" fill="#FFC857"/>
<path d="M14 40 l-8 -4 M106 40 l8 -4 M20 22 l-6 -6 M100 22 l6 -6" fill="none" stroke="#FFC857" stroke-width="5"/>
<path d="M54 52 h12 v8 h-12Z" fill="#B5B9D4"/>
<path d="M22 78 C22 62 98 62 98 78 C98 90 80 96 60 96 C40 96 22 90 22 78Z" fill="#E0A955"/>
<path d="M98 76 C110 72 112 88 100 90" fill="none" stroke-width="6"/>
<path d="M22 74 l-14 -8" fill="none" stroke-width="6"/>
<path d="M36 74 q8 -4 16 -4" fill="none" stroke="#fff" stroke-width="4"/>
<path d="M40 96 h40 v10 h-40Z" fill="#B07A57"/>` },

  { id: "eiffeltower", en: "Eiffel Tower", da: "Eiffeltårnet", svg: `
<path d="M60 6 v12" fill="none" stroke-width="4"/>
<path d="M54 18 h12 l4 30 h-20Z" fill="#B07A57"/>
<path d="M46 48 h28 l8 26 h-44Z" fill="#B07A57"/>
<path d="M36 74 h48 l14 34 h-16 q-6 -18 -22 -18 q-16 0 -22 18 h-16Z" fill="#B07A57"/>
<path d="M42 48 h36 M32 74 h56" fill="none" stroke-width="6"/>
<path d="M56 24 l8 8 M64 24 l-8 8 M50 54 l20 14 M70 54 l-20 14" fill="none" stroke="#8E5E40" stroke-width="2.5"/>
<path d="M98 20 l2 5 5 1 -4 3 1 5 -4 -3 -4 3 1 -5 -4 -3 5 -1z" fill="#FFE37A" stroke-width="2"/>` },

  { id: "ballot", en: "Voting", da: "Afstemning", svg: `
<rect x="18" y="54" width="84" height="52" rx="6" fill="#7FC8F8"/>
<path d="M34 54 h52" fill="none" stroke-width="8"/>
<g transform="rotate(-8 60 34)"><rect x="40" y="12" width="40" height="44" rx="3" fill="#fff"/><path d="M48 32 l6 6 12 -14" fill="none" stroke="#5BB46C" stroke-width="5"/></g>
<path d="M40 76 l6 6 6 -6 6 6 6 -6 6 6 6 -6" fill="none" stroke="#fff" stroke-width="3"/>` },

  { id: "teddy", en: "Toys", da: "Legetøj", svg: `
<circle cx="34" cy="26" r="12" fill="#B07A57"/><circle cx="86" cy="26" r="12" fill="#B07A57"/>
<circle cx="34" cy="26" r="5" fill="#F4C976" stroke="none"/><circle cx="86" cy="26" r="5" fill="#F4C976" stroke="none"/>
<ellipse cx="60" cy="84" rx="30" ry="26" fill="#B07A57"/>
<circle cx="30" cy="80" r="11" fill="#B07A57"/><circle cx="90" cy="80" r="11" fill="#B07A57"/><circle cx="40" cy="106" r="11" fill="#B07A57"/><circle cx="80" cy="106" r="11" fill="#B07A57"/>
<ellipse cx="60" cy="88" rx="16" ry="14" fill="#F4C976" stroke="none"/>
<circle cx="60" cy="42" r="26" fill="#B07A57"/>
<ellipse cx="60" cy="52" rx="12" ry="9" fill="#F4C976"/>
<circle cx="50" cy="38" r="3.5" fill="#3B3355" stroke="none"/><circle cx="70" cy="38" r="3.5" fill="#3B3355" stroke="none"/>
<path d="M56 48 h8 l-4 4Z" fill="#3B3355" stroke-width="2.5"/>
<path d="M50 66 l10 6 10 -6 -4 10 h-12Z" fill="#E8556D" stroke-width="3"/>` },

  { id: "banana", en: "Banana", da: "Banan", svg: `
<path d="M18 40 C14 76 44 104 92 96 C100 94 104 88 98 86 C64 90 40 72 34 40 C32 32 20 30 18 40Z" fill="#FFE37A"/>
<path d="M34 40 C40 72 64 90 98 86 C104 88 100 94 92 96" fill="none"/>
<path d="M30 56 C36 74 52 86 72 90" fill="none" stroke="#E0A955" stroke-width="3"/>
<path d="M22 38 l-4 -14 8 -2 4 14" fill="#B07A57"/>
<path d="M98 86 l6 2" fill="none" stroke="#8E5E40" stroke-width="5"/>` },

  { id: "bed", en: "Bed", da: "Seng", svg: `
<path d="M14 30 v76 M106 60 v46" fill="none" stroke="#3B3355" stroke-width="10"/>
<path d="M14 30 v76 M106 60 v46" fill="none" stroke="#B07A57" stroke-width="4"/>
<rect x="14" y="66" width="92" height="22" rx="4" fill="#B07A57"/>
<rect x="22" y="48" width="28" height="18" rx="8" fill="#fff"/>
<path d="M44 66 C44 50 106 50 106 62 V70 H44Z" fill="#7FC8F8"/>
<path d="M60 58 l4 6 M78 56 l4 6 M94 58 l4 6" fill="none" stroke="#fff" stroke-width="3"/>
<path d="M82 22 h12 l-12 14 h12 M98 8 h8 l-8 10 h8" fill="none" stroke="#A78BFA" stroke-width="3.5"/>` },

  { id: "car", en: "Car", da: "Bil", svg: `
<path d="M10 82 V66 q0 -8 10 -10 l14 -4 l14 -18 q4 -4 10 -4 h18 q8 0 12 6 l10 16 h8 q14 2 14 14 v18Z" fill="#E8556D"/>
<path d="M44 52 l10 -14 h10 v14Z M72 52 v-14 h6 q4 0 6 4 l6 10Z" fill="#B7E0FB"/>
<circle cx="32" cy="84" r="12" fill="#3B3355"/><circle cx="88" cy="84" r="12" fill="#3B3355"/>
<circle cx="32" cy="84" r="5" fill="#C9CCE0" stroke="none"/><circle cx="88" cy="84" r="5" fill="#C9CCE0" stroke="none"/>
<circle cx="106" cy="66" r="4" fill="#FFE37A" stroke-width="3"/>
<path d="M62 62 h8" fill="none" stroke-width="4"/>
<path d="M4 98 h112" fill="none" stroke="#C9CCE0" stroke-width="4"/>` },

  { id: "bus", en: "Bus", da: "Bus", svg: `
<rect x="10" y="26" width="100" height="62" rx="10" fill="#FFC857"/>
<path d="M18 36 h18 v20 h-18Z M42 36 h18 v20 h-18Z M66 36 h18 v20 h-18Z M90 36 h12 v34 h-12Z" fill="#B7E0FB"/>
<path d="M10 66 h80" fill="none" stroke="#E0A955" stroke-width="5"/>
<circle cx="32" cy="90" r="11" fill="#3B3355"/><circle cx="86" cy="90" r="11" fill="#3B3355"/>
<circle cx="32" cy="90" r="4" fill="#C9CCE0" stroke="none"/><circle cx="86" cy="90" r="4" fill="#C9CCE0" stroke="none"/>
<circle cx="20" cy="76" r="4" fill="#fff" stroke-width="3"/>` },

  { id: "airplane", en: "Airplane", da: "Fly", svg: `
<path d="M18 30 q4 -8 12 -6 q6 -6 12 0 q8 0 6 8Z M80 98 q4 -8 12 -6 q6 -6 12 0 q8 0 6 8Z" fill="#fff" stroke-width="3"/>
<path d="M14 68 C14 58 30 54 50 54 H96 C108 54 114 60 112 66 C110 72 100 74 90 74 H34 C22 74 14 72 14 68Z" fill="#fff"/>
<path d="M50 56 L64 26 H76 L72 56Z M56 74 L66 98 H76 L74 74Z" fill="#7FC8F8"/>
<path d="M18 62 L10 42 H22 L32 56Z" fill="#E8556D"/>
<path d="M98 58 h8 a6 6 0 0 1 4 6 h-12Z" fill="#B7E0FB" stroke-width="3"/>
<circle cx="44" cy="63" r="3" fill="#B7E0FB" stroke-width="2"/><circle cx="56" cy="63" r="3" fill="#B7E0FB" stroke-width="2"/><circle cx="68" cy="63" r="3" fill="#B7E0FB" stroke-width="2"/><circle cx="80" cy="63" r="3" fill="#B7E0FB" stroke-width="2"/>` },

  { id: "chair", en: "Furniture", da: "Møbler", svg: `
<path d="M34 12 h52 a6 6 0 0 1 6 6 v44 h-64 v-44 a6 6 0 0 1 6 -6Z" fill="#E07A5F"/>
<path d="M42 24 v34 M60 24 v34 M78 24 v34" fill="none" stroke="#C8604A" stroke-width="4"/>
<rect x="22" y="60" width="76" height="14" rx="5" fill="#FFC857"/>
<path d="M30 74 v34 M90 74 v34 M44 74 v24 M76 74 v24" fill="none" stroke="#3B3355" stroke-width="8"/>
<path d="M30 74 v34 M90 74 v34 M44 74 v24 M76 74 v24" fill="none" stroke="#B07A57" stroke-width="3"/>` },

  { id: "mug", en: "Cup", da: "Kop", svg: `
<path d="M42 26 q-6 -8 0 -16 M58 26 q-6 -8 0 -16 M74 26 q-6 -8 0 -16" fill="none" stroke="#C9CCE0" stroke-width="5"/>
<path d="M84 46 h8 a14 14 0 0 1 0 28 h-8" fill="none" stroke="#3B3355" stroke-width="12"/>
<path d="M84 46 h8 a14 14 0 0 1 0 28 h-8" fill="none" stroke="#7FC8F8" stroke-width="5"/>
<path d="M22 34 h66 v52 a16 16 0 0 1 -16 16 h-34 a16 16 0 0 1 -16 -16Z" fill="#7FC8F8"/>
<path d="M22 34 h66" fill="none"/><ellipse cx="55" cy="36" rx="30" ry="4" fill="#B07A57" stroke="none"/>
<path d="M44 62 a6 6 0 0 1 11 -2 a6 6 0 0 1 11 2 c0 8 -11 14 -11 14 c0 0 -11 -6 -11 -14Z" fill="#FF6B81" stroke-width="3"/>
<path d="M14 108 h84" fill="none" stroke="#E9DCC4" stroke-width="5"/>` },

  { id: "computer", en: "Computer", da: "Computer", svg: `
<rect x="12" y="16" width="96" height="66" rx="8" fill="#3B3355"/>
<rect x="20" y="24" width="80" height="50" rx="3" fill="#7FC8F8" stroke="none"/>
<path d="M30 40 h28 M30 50 h40 M30 60 h20" fill="none" stroke="#fff" stroke-width="5"/>
<circle cx="84" cy="46" r="8" fill="#FFC857" stroke-width="3"/>
<path d="M50 82 l-6 16 h32 l-6 -16" fill="#C9CCE0"/>
<rect x="30" y="98" width="60" height="8" rx="4" fill="#B5B9D4"/>` },

  { id: "mouse", en: "Mouse", da: "Mus", svg: `
<circle cx="40" cy="34" r="16" fill="#C9CCE0"/><circle cx="40" cy="34" r="8" fill="#FF9BB0" stroke="none"/>
<path d="M98 84 C108 84 116 92 108 100 C100 108 88 104 84 112" fill="none" stroke="#FF9BB0" stroke-width="5"/>
<path d="M14 72 C14 50 36 38 60 42 C86 46 102 62 100 80 C98 96 80 102 60 102 C36 102 14 94 14 72Z" fill="#C9CCE0"/>
<circle cx="66" cy="34" r="16" fill="#C9CCE0"/><circle cx="66" cy="34" r="8" fill="#FF9BB0" stroke="none"/>
<circle cx="14" cy="74" r="5" fill="#FF6B81"/>
<circle cx="34" cy="64" r="4" fill="#3B3355" stroke="none"/>
<path d="M18 82 l-12 4 M20 86 l-10 8" fill="none" stroke-width="2.5"/>` },

  { id: "fox", en: "Fox", da: "Ræv", svg: `
<path d="M20 14 L46 36 L30 50Z M100 14 L74 36 L90 50Z" fill="#FF7A45"/>
<path d="M26 26 l12 12 -8 6Z M94 26 l-12 12 8 6Z" fill="#3B3355" stroke="none"/>
<path d="M60 30 C84 30 100 42 104 60 C96 78 76 94 60 104 C44 94 24 78 16 60 C20 42 36 30 60 30Z" fill="#FF7A45"/>
<path d="M16 60 C30 62 44 70 60 104 C76 70 90 62 104 60 C96 78 76 94 60 104 C44 94 24 78 16 60Z" fill="#fff"/>
<circle cx="44" cy="56" r="4.5" fill="#3B3355" stroke="none"/><circle cx="76" cy="56" r="4.5" fill="#3B3355" stroke="none"/>
<path d="M54 92 h12 l-6 8Z" fill="#3B3355" stroke-width="3"/>` },

  { id: "pig", en: "Pig", da: "Gris", svg: `
<path d="M24 36 L22 14 L44 26Z M96 36 L98 14 L76 26Z" fill="#FF9BB0"/>
<circle cx="60" cy="62" r="44" fill="#FFB5C5"/>
<ellipse cx="60" cy="74" rx="22" ry="16" fill="#FF9BB0"/>
<ellipse cx="52" cy="74" rx="4" ry="6" fill="#E8556D" stroke="none"/><ellipse cx="68" cy="74" rx="4" ry="6" fill="#E8556D" stroke="none"/>
<circle cx="42" cy="48" r="4.5" fill="#3B3355" stroke="none"/><circle cx="78" cy="48" r="4.5" fill="#3B3355" stroke="none"/>
<path d="M30 36 q4 -8 12 -10" fill="none" stroke="#fff" stroke-width="4" opacity=".8"/>` },

  { id: "shoes", en: "Clothes", da: "Tøj", svg: `
<path d="M38 12 L18 22 L8 44 L22 52 L28 44 V96 H92 V44 L98 52 L112 44 L102 22 L82 12 C78 22 70 26 60 26 C50 26 42 22 38 12Z" fill="#7FC8F8"/>
<path d="M38 12 C42 22 50 26 60 26 C70 26 78 22 82 12" fill="none" stroke-width="5"/>
<path d="M60 44 l5 10 11 1 -8 8 2 11 -10 -5 -10 5 2 -11 -8 -8 11 -1z" fill="#FFC857" stroke-width="3"/>
<path d="M28 84 h64" fill="none" stroke="#4A90D9" stroke-width="4"/>` },

  { id: "scissors", en: "Scissors", da: "Saks", svg: `
<path d="M50 62 L96 14 M70 62 L24 14" fill="none" stroke="#3B3355" stroke-width="12"/>
<path d="M50 62 L96 14 M70 62 L24 14" fill="none" stroke="#C9CCE0" stroke-width="5"/>
<circle cx="60" cy="52" r="5" fill="#FFC857"/>
<circle cx="34" cy="88" r="18" fill="#E8556D"/><circle cx="86" cy="88" r="18" fill="#E8556D"/>
<circle cx="34" cy="88" r="8" fill="#fff"/><circle cx="86" cy="88" r="8" fill="#fff"/>
<path d="M46 74 l8 -10 M74 74 l-8 -10" fill="none" stroke="#E8556D" stroke-width="8"/>` },

  { id: "window", en: "Window", da: "Vindue", svg: `
<rect x="18" y="14" width="84" height="86" rx="6" fill="#B07A57"/>
<rect x="26" y="22" width="68" height="70" fill="#B7E0FB"/>
<circle cx="76" cy="40" r="9" fill="#FFC857" stroke-width="3"/>
<path d="M30 70 a8 8 0 0 1 8 -10 a10 10 0 0 1 18 2 a6 6 0 0 1 2 10 h-26Z" fill="#fff" stroke-width="3"/>
<path d="M60 22 v70 M26 57 h68" fill="none" stroke="#B07A57" stroke-width="6"/>
<path d="M12 100 h96 v8 h-96Z" fill="#E07A5F"/>
<circle cx="32" cy="96" r="6" fill="#FF6B81" stroke-width="3"/><circle cx="88" cy="96" r="6" fill="#FFC857" stroke-width="3"/>` },

  { id: "chocolate", en: "Chocolate", da: "Chokolade", svg: `
<path d="M24 44 l40 -30 32 6 -6 46Z" fill="#E5E1EE"/>
<rect x="24" y="44" width="66" height="66" rx="5" fill="#8E5E40"/>
<path d="M46 44 v66 M68 44 v66 M24 66 h66 M24 88 h66" fill="none" stroke="#6E452E" stroke-width="4"/>
<path d="M30 50 h10 M52 50 h10 M74 50 h10" fill="none" stroke="#B07A57" stroke-width="3"/>` },

  { id: "hand", en: "Hand", da: "Hånd", svg: `
<path d="M38 104 C30 92 22 76 18 66 C14 58 22 52 28 58 L38 70 V26 a6 6 0 0 1 12 0 V56 V18 a6 6 0 0 1 12 0 V56 V22 a6 6 0 0 1 12 0 V58 V34 a6 6 0 0 1 12 0 V74 C86 92 80 104 66 108 C54 110 44 110 38 104Z" fill="#FFC9A8"/>
<path d="M50 56 V48 M62 56 V46 M74 58 V50" fill="none" stroke-width="3"/>
<path d="M98 16 l2 5 5 1 -4 3 1 5 -4 -3 -4 3 1 -5 -4 -3 5 -1z" fill="#FFE37A" stroke-width="2"/>` },

  { id: "party", en: "Party", da: "Fest", svg: `
<path d="M44 66 C44 76 52 82 50 96 C48 104 56 108 54 114 M80 70 C80 82 74 90 78 102" fill="none" stroke-width="2.5"/>
<path d="M44 8 C62 8 70 22 68 36 C66 52 54 62 44 64 C34 62 22 52 20 36 C18 22 26 8 44 8Z" fill="#E8556D"/>
<path d="M40 64 h8 l-4 6Z" fill="#E8556D" stroke-width="3"/>
<path d="M80 22 C96 22 104 34 102 46 C100 60 90 68 80 70 C70 68 60 60 58 46 C56 34 64 22 80 22Z" fill="#7FC8F8"/>
<path d="M76 70 h8 l-4 6Z" fill="#7FC8F8" stroke-width="3"/>
<path d="M30 22 q4 -8 12 -8 M68 36 q4 -8 10 -8" fill="none" stroke="#fff" stroke-width="4"/>
<path d="M14 82 l4 4 M22 96 l-4 4 M100 92 l4 -4 M96 106 l6 2" fill="none" stroke="#FFC857" stroke-width="4"/>` },

  { id: "lemon", en: "Lemon", da: "Citron", svg: `
<path d="M86 22 q10 -8 20 -6 q-2 12 -14 16" fill="#7BD389"/>
<path d="M20 78 C10 70 14 50 30 38 C48 24 76 20 90 32 C104 44 102 70 86 84 C70 98 44 100 30 92 C26 90 22 86 20 78Z" fill="#FFE37A"/>
<path d="M20 78 q-8 2 -10 8 q8 0 12 -4Z" fill="#FFE37A" stroke-width="3"/>
<path d="M40 50 q8 -10 20 -12" fill="none" stroke="#fff" stroke-width="5"/>
<circle cx="46" cy="66" r="4" fill="#3B3355" stroke="none"/><circle cx="70" cy="62" r="4" fill="#3B3355" stroke="none"/>
<path d="M50 80 q8 -6 16 0 q-8 -2 -16 0Z" fill="#3B3355" stroke-width="3"/>
<path d="M38 76 l-4 -2 M80 70 l4 -3" fill="none" stroke="#FF9BB0" stroke-width="4"/>` },

  { id: "giraffe", en: "Giraffe", da: "Giraf", svg: `
<path d="M14 116 C18 96 36 88 46 86 L48 52 L72 52 L74 86 C88 90 104 98 106 116Z" fill="#FFC857"/>
<path d="M52 24 l-2 -12 M66 22 l2 -12" fill="none" stroke-width="4"/>
<circle cx="50" cy="10" r="5" fill="#B07A57"/><circle cx="68" cy="9" r="5" fill="#B07A57"/>
<path d="M40 32 l-14 -6 6 12Z" fill="#E0A955" stroke-width="3"/>
<path d="M38 40 C38 26 50 20 62 22 C76 24 98 32 100 46 C102 58 92 62 80 60 L60 60 C46 60 38 52 38 40Z" fill="#FFC857"/>
<ellipse cx="90" cy="50" rx="11" ry="9" fill="#F4C976"/>
<circle cx="92" cy="46" r="2" fill="#3B3355" stroke="none"/><circle cx="96" cy="52" r="2" fill="#3B3355" stroke="none"/>
<circle cx="60" cy="38" r="5" fill="#3B3355" stroke="none"/><circle cx="62" cy="36" r="1.6" fill="#fff" stroke="none"/>
<circle cx="66" cy="50" r="4" fill="#FF9BB0" stroke="none" opacity=".8"/>
<path d="M52 68 q6 -4 10 2 q-2 6 -8 5 q-4 -2 -2 -7Z M60 82 q6 -3 9 2 q-2 6 -8 4 q-3 -2 -1 -6Z M28 104 q6 -5 11 0 q-2 7 -9 6 q-4 -2 -2 -6Z M80 98 q6 -4 10 1 q-1 7 -8 6 q-4 -2 -2 -7Z M54 104 q5 -3 9 1 q-2 6 -7 5 q-4 -2 -2 -6Z" fill="#B07A57" stroke-width="2.5"/>` },
];
